import { ViewTreeAction, ViewTreeTypes } from '../actions/viewTreeActions';
import { ApiStatus } from '../../models';
import { ViewsAction, ViewsActionTypes } from '../actions/viewActions';

export const initialViewTreeState: IViewTreeState = {
  loadingStatus: ApiStatus.LOADING,
  nodes: null
}

export interface IViewTreeState {
  loadingStatus: ApiStatus;
  nodes: any;
}

export default function viewTreeReducer(
  state: IViewTreeState = initialViewTreeState,
  action: ViewTreeAction | ViewsAction
): IViewTreeState {
  switch (action.type) {
    case ViewTreeTypes.LOAD_VIEW_TREE:
    case ViewTreeTypes.LOADING_VIEW_TREE:
        return {
        ...state,
        loadingStatus: ApiStatus.LOADING
      };
    case ViewTreeTypes.LOADING_VIEW_TREE_FAILED:
        return {
        ...state,
        loadingStatus: ApiStatus.FAILED
      };
    case ViewTreeTypes.LOADED_VIEW_TREE:
        // this is called on init only
      return {
        ...state,
        nodes: action.payload,
        loadingStatus: ApiStatus.LOADED
      }
    case ViewsActionTypes.CREATED_VIEW:
      return {
        ...state,
        nodes: state.nodes ?
          [ action.payload ].concat(state.nodes) :
          [ action.payload ]
      };
    case ViewsActionTypes.REMOVED_VIEW:
      return {
        ...state,
        nodes: state.nodes ?
          state.nodes.filter((node: any) => node.id !== action.payload) :
          [ action.payload ]
      };
    case ViewsActionTypes.SAVED_VIEW:
      return {
        ...state,
        nodes: state.nodes ?
          state.nodes.map((node: any) => node.uid !== action.payload.view.id ?
            node :
            ({
              ...node,
              name: action.payload.view.name
            })
          ) : [ {
            id: action.payload.view.id,
            name: action.payload.view.name
          }]
      };
    default:
      return state;
  }
};
